module.exports = __webpack_public_path__ + "img/plus.2e34836f.svg";